// extracted by mini-css-extract-plugin
export var formPart = "lost-objects-form-module--formPart--35e5a";
export var globalError = "lost-objects-form-module--globalError--c19e3";
export var submitButton = "lost-objects-form-module--submitButton--b4abe";
export var successMessage = "lost-objects-form-module--successMessage--02d67";
export var title = "lost-objects-form-module--title--17afa";